export const constants = {
  LOGGED_IN: 'LoggedIn',
  SEND_MESSAGE: 'SendMessage',
  SEND_TEMPLATE: 'TemplateSent',
  IPD_TRACKING: 'IPD_Tracking',
  CHANNEL_LIST: 'ChannelList',
  CHANNEL_OPEN: 'ChannelOpen',
  BLANK_ERROR:'BlankError'
}